import React from "react";
import { AppShell } from "../../components";

const Dashboard = () => {
  return <AppShell pageTitle="DashBoard">Dashboard</AppShell>;
};

export default Dashboard;
